import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class UsersService {

  users:any[]=[];
  currentUser:number  = 0;  
  showNavbar :boolean = false  ;
  userName:string = ""
  constructor() { }
  
}
